// Shared types for Webflow-sourced data.
// Serve the purpose of defining an interface between the web and api.

/**
 * A single URL entry for a Webflow-backed sitemap (marketing landing pages or
 * blog articles). `lastModifiedAt` is an ISO-8601 UTC timestamp, or null when
 * Webflow exposes no last-modified date for the page/item.
 */
export type WebflowSitemapUrlItem = {
  url: string
  lastModifiedAt: string | null
}
